module.exports = __webpack_public_path__ + "static/media/DesktopMobileBG.c4203548.mp4";